var script_loaded = 0;
var activityEvents = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click",
  "keypress",
  "touchmove",
];

function loadDeferredContent() {
  if (!script_loaded) {
    let scriptsToProcess = document.querySelectorAll("script[data-src]"),
      stylesToProcess = document.querySelectorAll("link[data-href]");
    scriptsToProcess.forEach((script) => {
      script.src = script.dataset.src;
      delete script.dataset.src;
    });
    stylesToProcess.forEach((link) => {
      link.href = link.dataset.href;
      delete link.dataset.href;
    });
    document.dispatchEvent(new CustomEvent("StartAsyncLoading"));
    document.dispatchEvent(new CustomEvent("StartKernelLoading"));
    script_loaded = 1;
  console.log("scripts loaded");
    removeActivityListeners();
  }
}
  
const removeActivityListeners = () => {
  activityEvents.forEach( e => {
    window.removeEventListener(e, loadDeferredContent);
  });
};
const loadWithDelay = () => {
  setTimeout(loadDeferredContent, 12000);
};
activityEvents.forEach(e => {
  window.addEventListener(e, loadDeferredContent, false);
});

document.addEventListener("load", loadWithDelay, false);
window.addEventListener("load", loadWithDelay, false);
